import { toastError, toastSuccess } from '@components/Toast/Toast';
import { useBankProfile } from '@contexts/BankProfileContext';
import { useAuth } from '@hooks/useAuth';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import axios from 'axios';
import { useTranslation } from 'react-i18next';
import type { CreatePaymentTemplate } from 'types/templates';

export const useUpdateTemplate = () => {
	const queryClient = useQueryClient();
	const { session } = useAuth();
	const { selectedProfile } = useBankProfile();
	const { t } = useTranslation('', { keyPrefix: 'templatesForm' });

	const updateTemplate = async ({
		uuid,
		...template
	}: CreatePaymentTemplate & { uuid: string }) => {
		const { data } = await axios.put(
			`${import.meta.env.VITE_API_HOST}/api/v1/profiles/${selectedProfile.id}/payment-templates/${uuid}`,
			template,
			{
				headers: {
					Authorization: session?.tokenized,
				},
			},
		);

		return data;
	};

	return useMutation({
		mutationFn: updateTemplate,
		onSuccess: async () => {
			toastSuccess(t('successUpdate'));
			await queryClient.removeQueries({
				queryKey: ['templates'],
			});
		},
		onError: (err) => {
			toastError(t('failedUpdate'));

			throw err;
		},
	});
};
